import { useState, useEffect } from 'react';
import { useFragment, graphql } from 'react-relay';
import PropTypes from 'prop-types';

// components
import { addForceFavoriteRefetchHandler } from 'dibs-buyer-layout/exports/loginHandlers';

import { FavoritesItem } from '../../components/global/FavoriteIcons/FavoritesItem';
import { FavoritesProvider } from '../../components/global/FavoriteIcons/FavoritesProvider';

// helpers
import { locations } from '../../utils/tracking/shared/favoritesTracking';

import styles from './PdpSharedSidebarFavorites.scss';

export function PdpSharedSidebarFavorites(props) {
    // Todo: Directly pass in userId
    const { isClient, environment, userId, item: itemRef, showHeartCount, onFavorited } = props;

    const item = useFragment(
        graphql`
            fragment PdpSharedSidebarFavorites_item on Item {
                ...FavoritesItem_item
                serviceId
                isAuctionEnabled
            }
        `,
        itemRef
    );
    const [shouldFavoritesProviderRefetch, setShouldFavoritesProviderRefetch] = useState(false);

    useEffect(() => {
        addForceFavoriteRefetchHandler(() => {
            setShouldFavoritesProviderRefetch(true);
        });
    }, [setShouldFavoritesProviderRefetch]);

    return (
        <FavoritesProvider
            environment={environment}
            location={item?.isAuctionEnabled ? locations.AUCTION_PDP : locations.SIDEBAR}
            disable={!isClient}
            userId={userId}
            itemIds={[item?.serviceId]}
            shouldAutoFavorite
            shouldRefetch={shouldFavoritesProviderRefetch}
            shouldShowHeartCount={showHeartCount}
        >
            {
                // eslint-disable-next-line
                ({ props: renderProps }) => (
                    <FavoritesItem
                        {...renderProps}
                        fetchFolder={renderProps?.fetchFolder}
                        item={item}
                        itemImage={props.itemImage}
                        wrapperClass={props.wrapperClass}
                        heartIconWrapperClass={props.heartIconWrapperClass}
                        folderIconWrapperClass={props.folderIconWrapperClass}
                        animateHeartPulse
                        heartIconClass={styles.icon}
                        folderIconClass={styles.icon}
                        onFavorited={onFavorited}
                    />
                )
            }
        </FavoritesProvider>
    );
}

PdpSharedSidebarFavorites.propTypes = {
    userId: PropTypes.string,
    isClient: PropTypes.bool.isRequired,
    wrapperClass: PropTypes.string,
    heartIconWrapperClass: PropTypes.string,
    folderIconWrapperClass: PropTypes.string,
    environment: PropTypes.object.isRequired,
    itemImage: PropTypes.string,
    item: PropTypes.object.isRequired,
    showHeartCount: PropTypes.bool,
    onFavorited: PropTypes.func,
};
